export const createStaffMembersRequests = (client) => ({
    listStaffMembers: async (params) => {
        const { data, meta, links } = await client.api.get("staff_members", {
            params: params,
        });
        return { data, meta, links };
    },
    createStaffMember: async (payload) => {
        const { data } = await client.api.create("staff_member", payload);
        return { data };
    },
    updateStaffMember: async (payload) => {
        const { data } = await client.api.update("staff_member", payload);
        return { data };
    },
});
//# sourceMappingURL=index.js.map